<div class="profile__wrapper">
  <form class="professional__form" [formGroup]="professionalDataForm">
    <i
      class="icon-pencil"
      [class.grey]="isEditable"
      (click)="switchEdit()"
      *ngIf="ableToEdit"
    ></i>
    <fieldset class="form__fieldset" [disabled]="!isEditable">
      <div class="row">
        <div class="col-6">
          <div class="professional__form-item row align-items-center">
            <label for="tech-stak" class="label-input col-4"
              >Tech stack main</label
            >
            <div class="col-4">
              <app-dropdown
                [items]="itemsStacksMain"
                formControlName="techStackMain"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>
          <div class="professional__form-item row align-items-center">
            <label for="tech-stak-sec" class="label-input col-4"
              >Tech stack secondary</label
            >
            <div class="col-4">
              <app-dropdown
                [items]="itemsStacksSecondary"
                [isMultiselect]="true"
                formControlName="techStackSecondary"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>
          <div class="professional__form-item row align-items-center">
            <label for="framework" class="label-input col-4">Framework</label>
            <div class="col-4">
              <app-dropdown
                [items]="frameworks"
                formControlName="frameworks"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
                [isMultiselect]="true"
              ></app-dropdown>
            </div>
          </div>
          <div class="professional__form-item row align-items-center">
            <label
              for="english-lvl"
              class="label-input col-4"
              appMarkAsterisk
              [formGroup]="professionalDataForm"
              [controlName]="'englishLevelGrammar'"
              [touched]="
                professionalDataForm.get('englishLevelGrammar')!.touched
              "
              >English level grammar</label
            >
            <div class="col-4 relative">
              <app-dropdown
                [items]="englishLevelGrammarOptions"
                formControlName="englishLevelGrammar"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
              <app-error-field
                [displayError]="
                  isFieldInvalid('englishLevelGrammar', professionalDataForm)
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
            </div>
          </div>
          <div class="professional__form-item row align-items-center">
            <label
              for="english-lvl"
              class="label-input col-4"
              appMarkAsterisk
              [formGroup]="professionalDataForm"
              [controlName]="'englishLevelSpeaking'"
              [touched]="
                professionalDataForm.get('englishLevelSpeaking')!.touched
              "
              >English level speaking</label
            >
            <div class="col-4 relative">
              <app-dropdown
                [items]="englishLevelSpeakingOptions"
                formControlName="englishLevelSpeaking"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
              <app-error-field
                [displayError]="
                  isFieldInvalid('englishLevelSpeaking', professionalDataForm)
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
            </div>
          </div>
          <div class="professional__form-item row align-items-center">
            <div
              class="checkbox__wrapper col-4"
              [class.read-mode]="!isEditable"
            >
              <input type="checkbox" formControlName="isMentor" id="isMentor" />
              <label class="label-input col-3" for="isMentor">Is mentor</label>
            </div>
            <div
              class="checkbox__wrapper col-4"
              [class.read-mode]="!isEditable"
            >
              <input
                type="checkbox"
                formControlName="isInterviewer"
                id="isInterviewer"
              />
              <label class="label-input col-5" for="isInterviewer"
                >Is interviewer</label
              >
            </div>
          </div>

          <div class="security__training">Security training</div>
          <div class="professional__form-item row align-items-center">
            <label
              for="result"
              class="label-input col-4"
              appMarkAsterisk
              [formGroup]="professionalDataForm"
              [controlName]="'securityTrainingResult'"
              [touched]="
                professionalDataForm.get('securityTrainingResult')!.touched
              "
              >Result</label
            >
            <div class="profesional__form-input col-4 relative">
              <input
                type="text"
                id="result"
                class="input__basic"
                placeholder=" "
                formControlName="securityTrainingResult"
              />
              <app-error-field
                [displayError]="
                  professionalDataForm
                    .get('securityTrainingResult')!
                    .hasError('maxlength')
                "
                [errorMessage]="'Max field length = 20'"
              ></app-error-field>
            </div>
          </div>

          <div class="professional__form-item row align-items-center">
            <label for="status" class="label-input col-4">Status</label>
            <div class="col-4">
              <app-dropdown
                [items]="statusOptions"
                formControlName="securityTrainingStatus"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>
          <div class="professional__form-item row align-items-center">
            <label for="attempts" class="label-input col-4"
              >Amount of attempts</label
            >
            <div class="col-4">
              <app-dropdown
                [items]="attemptsOptions"
                formControlName="ammountOfAttempts"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="general__projects" *ngIf="dataProjects.length">
            <div class="professional__table-desc">Projects</div>
            <div class="general_form-table mb-3">
              <app-table
                [tableType]="'maternity'"
                [headers]="projectsHeaders"
                [content]="dataProjects"
                [editMenu]="'icon'"
              ></app-table>
            </div>
          </div>
        </div>
      </div>

      <div
        class="professional__form-tables"
        [style.display]="dataCert.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">Certifications</div>
        <app-table
          *ngIf="dataCert.length"
          [tableType]="typeOfTable"
          [headers]="headersCert"
          [content]="dataCert"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            nonTrainingTableActions(
              $event,
              dataCert,
              headersCert,
              ProfessionalTableType.Certifications
            )
          "
        ></app-table>
        <button
          *ngIf="dataCert.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="
            addNewTableData(headersCert, ProfessionalTableType.Certifications)
          "
        ></button>
      </div>
      <div
        class="professional__form-tables"
        [style.display]="dataConf.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">
          {{ ProfessionalTableType.Conference }}
        </div>
        <app-table
          *ngIf="dataConf.length"
          [tableType]="typeOfTable"
          [headers]="headersConf"
          [content]="dataConf"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            trainingActions(
              $event,
              headersConf,
              dataConf,
              ProfessionalTableType.Conference
            )
          "
        ></app-table>
        <button
          *ngIf="dataConf.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="addTraining(ProfessionalTableType.Conference, headersConf)"
        ></button>
      </div>
      <div
        class="professional__form-tables"
        [style.display]="dataAssignedMentor.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">Assigned mentor</div>
        <app-table
          *ngIf="dataAssignedMentor.length"
          [tableType]="typeOfTable"
          [headers]="assignedMentorHeaders"
          [content]="dataAssignedMentor"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            nonTrainingTableActions(
              $event,
              dataAssignedMentor,
              assignedMentorHeaders,
              ProfessionalTableType.AssignedMentors
            )
          "
        ></app-table>
        <button
          *ngIf="dataAssignedMentor.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="
            addNewTableData(
              assignedMentorHeaders,
              ProfessionalTableType.AssignedMentors
            )
          "
        ></button>
      </div>
      <div class="professional__form-tables" *ngIf="isMentor">
        <div class="professional__table-desc">Mentorship of others</div>
        <app-table
          *ngIf="dataMentor.length; else nomentorship"
          [tableType]="'material'"
          [headers]="headersMentor"
          [content]="dataMentor"
          [showEditFields]="isEditable"
        ></app-table>
        <ng-template #nomentorship>
          <div class="profile__nodata">
            There is no mentorsip data for that employee
          </div>
        </ng-template>
      </div>
      <div
        class="professional__form-tables"
        [style.display]="dataInterviewInterviewee.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">Tech interview(Interviewee)</div>
        <app-table
          *ngIf="dataInterviewInterviewee.length"
          [tableType]="typeOfTable"
          [headers]="headersInterviewInterviewee"
          [content]="dataInterviewInterviewee"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            nonTrainingTableActions(
              $event,
              dataInterviewInterviewee,
              headersInterviewInterviewee,
              ProfessionalTableType.TechInterview
            )
          "
        >
        </app-table>
        <button
          *ngIf="dataInterviewInterviewee.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="
            addNewTableData(
              headersInterviewInterviewee,
              ProfessionalTableType.TechInterview
            )
          "
        ></button>
      </div>
      <div class="professional__form-tables" *ngIf="isInterviewer">
        <div class="professional__table-desc">Tech interview(Interviewer)</div>
        <app-table
          *ngIf="dataInterviewInterviewer.length; else nointerview"
          [tableType]="'material'"
          [headers]="headersInterviewInterviewer"
          [content]="dataInterviewInterviewer"
        >
        </app-table>
        <ng-template #nointerview>
          <div class="profile__nodata">
            There is no interview for that employee
          </div>
        </ng-template>
      </div>
      <div
        class="professional__form-tables"
        [style.display]="coursesData.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">
          {{ ProfessionalTableType.EnglishCourses }}
        </div>
        <app-table
          *ngIf="coursesData.length"
          [tableType]="typeOfTable"
          [headers]="coursesHeaders"
          [content]="coursesData"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            trainingActions(
              $event,
              coursesHeaders,
              coursesData,
              ProfessionalTableType.EnglishCourses
            )
          "
        ></app-table>
        <button
          *ngIf="coursesData.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="
            addTraining(ProfessionalTableType.EnglishCourses, coursesHeaders)
          "
        ></button>
      </div>
      <div
        class="professional__form-tables"
        [style.display]="dataCourses.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">
          {{ ProfessionalTableType.InternalCourses }}
        </div>
        <app-table
          *ngIf="dataCourses.length"
          [tableType]="typeOfTable"
          [headers]="headersCourses"
          [content]="dataCourses"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            trainingActions(
              $event,
              headersCourses,
              dataCourses,
              ProfessionalTableType.InternalCourses
            )
          "
        ></app-table>
        <button
          *ngIf="dataCourses.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="
            addTraining(ProfessionalTableType.InternalCourses, headersCourses)
          "
        ></button>
      </div>
      <div
        class="professional__form-tables"
        [style.display]="dataPresentation.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">
          {{ ProfessionalTableType.Presentation }}
        </div>
        <app-table
          *ngIf="dataPresentation.length"
          [tableType]="typeOfTable"
          [headers]="headersPresentation"
          [content]="dataPresentation"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            trainingActions(
              $event,
              headersPresentation,
              dataPresentation,
              ProfessionalTableType.Presentation
            )
          "
        >
        </app-table>
        <button
          *ngIf="dataPresentation.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="
            addTraining(ProfessionalTableType.Presentation, headersPresentation)
          "
        ></button>
      </div>
      <div
        class="professional__form-tables"
        [style.display]="dataTraining.length === 0 ? 'flex' : ''"
      >
        <div class="professional__table-desc">
          {{ ProfessionalTableType.Training }}
        </div>
        <app-table
          *ngIf="dataTraining.length"
          [tableType]="typeOfTable"
          [headers]="headersTraining"
          [content]="dataTraining"
          [editMenu]="'icon'"
          [showEditFields]="isEditable"
          (rowAction)="
            trainingActions(
              $event,
              headersTraining,
              dataTraining,
              ProfessionalTableType.Training
            )
          "
        >
        </app-table>
        <button
          *ngIf="dataTraining.length === 0 && isEditable"
          class="button button__add--normal table__btn"
          type="button"
          (click)="addTraining(ProfessionalTableType.Training, headersTraining)"
        ></button>
      </div>
    </fieldset>
  </form>
  <button
    class="button button__save profile__button"
    *ngIf="isEditable"
    (click)="saveData()"
    #saveButton
  >
    Save
  </button>
</div>
